import { Filter } from '@/components/icons'
import { Search } from '@/components/search'
import { Switch } from '@headlessui/react'
import { useTranslation } from 'react-i18next'

type Props = {
  tabActive: 'CLUBS' | 'EVENTS'
  onChangeTab: (tab: 'CLUBS' | 'EVENTS') => void
  searchText: string
  onChangeInput: (e: React.ChangeEvent<HTMLInputElement>) => void
  toggleFilter: () => void
  isNearMe: boolean
  onChangeSwitch: (checked: boolean) => void
  hasFilter?: boolean
}

export const Tab = ({
  tabActive,
  onChangeTab,
  searchText,
  onChangeInput,
  toggleFilter,
  isNearMe,
  onChangeSwitch,
  hasFilter,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-y-4 mt-4">
      <div className="flex gap-x-2">
        <button
          className={`px-4 rounded-full py-2 text-xs bg-white ${
            tabActive === 'CLUBS' ? 'text-navy-900' : 'bg-opacity-10 text-white text-opacity-50'
          }`}
          onClick={() => onChangeTab('CLUBS')}
        >
          {t('club.clubs')}
        </button>
        <button
          className={`px-4 rounded-full py-2 text-xs bg-white ${
            tabActive === 'EVENTS' ? 'text-navy-900' : 'bg-opacity-10 text-white text-opacity-50'
          }`}
          onClick={() => onChangeTab('EVENTS')}
        >
          {t('event.events')}
        </button>
      </div>
      <div className="flex flex-col sm:flex-row sm:gap-x-4 gap-y-2">
        <div className="flex gap-x-2 sm:gap-x-4 items-center">
          <Search searchText={searchText} onChangeInput={onChangeInput} className="py-2 px-4 w-full sm:w-52 gap-x-2" />
          <button className={`rounded-full ${hasFilter ? 'bg-white' : ''} hover:opacity-50`} onClick={toggleFilter}>
            <Filter className={`${hasFilter ? 'text-navy-900' : 'text-white'}`} />
          </button>
        </div>
        <div className="flex items-center gap-x-3">
          <Switch
            checked={isNearMe}
            onChange={(checked) => onChangeSwitch(checked)}
            className={`${
              isNearMe ? 'bg-primary-500' : 'bg-slate-300'
            } relative inline-flex h-6 w-11 items-center rounded-full`}
          >
            <span
              className={`${
                isNearMe ? 'translate-x-6' : 'translate-x-1'
              } inline-block h-4 w-4 transform rounded-full bg-white transition`}
            />
          </Switch>
          <span className="text-sm text-white">
            {tabActive === 'CLUBS' ? t('club.clubsNearMe') : t('event.eventsNearMe')}
          </span>
        </div>
      </div>
    </div>
  )
}
